/* eslint-disable */
import { Media, PluginContainerData } from './common.js';

import {
  AppEmbedData_AppType,
  AppEmbedData_ImageStyles_Position,
  AppEmbedData_ImageStyles_AspectRatio,
  AppEmbedData_ImageStyles_Resizing,
  AppEmbedData_RibbonStyles_Placement,
  AppEmbedData_CardStyles_Type,
  AppEmbedData_CardStyles_Alignment,
  AppEmbedData_CardStyles_Layout,
} from './plugin_app_embed.enums.js';

export interface AppEmbedData {
  /** The type of Wix App content being embedded. */
  type: AppEmbedData_AppType;
  /** The ID of the embedded content. */
  itemId?: string;
  /** The name of the embedded content. */
  name?: string;
  /**
   * Deprecated: Use `image` instead.
   *
   * @deprecated
   */
  imageSrc?: string;
  /** The URL for the embedded content. */
  url?: string;
  /** An image for the embedded content. */
  image?: Media;
  /** Data for embedded Wix Bookings content. */
  bookingData?: AppEmbedData_BookingData | undefined;
  /** Data for embedded Wix Events content. */
  eventData?: AppEmbedData_EventData | undefined;
  /** Whether to hide the image. */
  hideImage?: boolean;
  /** Whether to hide the title. */
  hideTitle?: boolean;
  /** Whether to hide the price. */
  hidePrice?: boolean;
  /** Whether to hide the description (Event and Booking). */
  hideDescription?: boolean;
  /** Whether to hide the date and time (Event). */
  hideDateTime?: boolean;
  /** Whether to hide the location (Event). */
  hideLocation?: boolean;
  /** Whether to hide the duration (Booking). */
  hideDuration?: boolean;
  /** Whether to hide the button. */
  hideButton?: boolean;
  /** Whether to hide the ribbon. */
  hideRibbon?: boolean;
  /** Button styling options. */
  buttonStyles?: AppEmbedData_ButtonStyles;
  /** Image styling options. */
  imageStyles?: AppEmbedData_ImageStyles;
  /** Ribbon styling options. */
  ribbonStyles?: AppEmbedData_RibbonStyles;
  /** Card styling options. */
  cardStyles?: AppEmbedData_CardStyles;
  /** Styling for the app embed's container. */
  containerData?: PluginContainerData;
  /** Pricing data for embedded Wix App content. */
  pricingData?: AppEmbedData_PricingData;
}

export function appEmbedData_AppTypeFromJSON(object: any): AppEmbedData_AppType {
  switch (object) {
    case 0:
    case 'PRODUCT':
      return AppEmbedData_AppType.PRODUCT;
    case 1:
    case 'EVENT':
      return AppEmbedData_AppType.EVENT;
    case 2:
    case 'BOOKING':
      return AppEmbedData_AppType.BOOKING;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AppEmbedData_AppType.UNRECOGNIZED;
  }
}

export function appEmbedData_AppTypeToJSON(object: AppEmbedData_AppType): string {
  switch (object) {
    case AppEmbedData_AppType.PRODUCT:
      return 'PRODUCT';
    case AppEmbedData_AppType.EVENT:
      return 'EVENT';
    case AppEmbedData_AppType.BOOKING:
      return 'BOOKING';
    default:
      return 'UNKNOWN';
  }
}

export interface AppEmbedData_ButtonStyles {
  /** Text to display on the button. */
  buttonText?: string;
  /** Border width in pixels. */
  borderWidth?: number;
  /** Border radius in pixels. */
  borderRadius?: number;
  /** Border color as a hexadecimal value. */
  borderColor?: string;
  /** Text color as a hexadecimal value. */
  textColor?: string;
  /** Background color as a hexadecimal value. */
  backgroundColor?: string;
  /** Border color as a hexadecimal value (hover state). */
  borderColorHover?: string;
  /** Text color as a hexadecimal value (hover state). */
  textColorHover?: string;
  /** Background color as a hexadecimal value (hover state). */
  backgroundColorHover?: string;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: string;
}

export interface AppEmbedData_ImageStyles {
  /** Whether to hide the image. */
  hideImage?: boolean;
  /** Position of image. Defaults to `START`. */
  imagePosition: AppEmbedData_ImageStyles_Position;
  /** Aspect ratio for the image. Defaults to `SQUARE`. */
  aspectRatio: AppEmbedData_ImageStyles_AspectRatio;
  /** How the image should be resized. Defaults to `FILL`. */
  resizing: AppEmbedData_ImageStyles_Resizing;
  /** Image border color as a hexadecimal value. */
  borderColor?: string;
  /** Image border width in pixels. */
  borderWidth?: number;
  /** Image border radius in pixels. */
  borderRadius?: number;
}

export function appEmbedData_ImageStyles_PositionFromJSON(
  object: any
): AppEmbedData_ImageStyles_Position {
  switch (object) {
    case 0:
    case 'START':
      return AppEmbedData_ImageStyles_Position.START;
    case 1:
    case 'END':
      return AppEmbedData_ImageStyles_Position.END;
    case 2:
    case 'TOP':
      return AppEmbedData_ImageStyles_Position.TOP;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AppEmbedData_ImageStyles_Position.UNRECOGNIZED;
  }
}

export function appEmbedData_ImageStyles_PositionToJSON(
  object: AppEmbedData_ImageStyles_Position
): string {
  switch (object) {
    case AppEmbedData_ImageStyles_Position.START:
      return 'START';
    case AppEmbedData_ImageStyles_Position.END:
      return 'END';
    case AppEmbedData_ImageStyles_Position.TOP:
      return 'TOP';
    default:
      return 'UNKNOWN';
  }
}

export function appEmbedData_ImageStyles_AspectRatioFromJSON(
  object: any
): AppEmbedData_ImageStyles_AspectRatio {
  switch (object) {
    case 0:
    case 'SQUARE':
      return AppEmbedData_ImageStyles_AspectRatio.SQUARE;
    case 1:
    case 'RECTANGLE':
      return AppEmbedData_ImageStyles_AspectRatio.RECTANGLE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AppEmbedData_ImageStyles_AspectRatio.UNRECOGNIZED;
  }
}

export function appEmbedData_ImageStyles_AspectRatioToJSON(
  object: AppEmbedData_ImageStyles_AspectRatio
): string {
  switch (object) {
    case AppEmbedData_ImageStyles_AspectRatio.SQUARE:
      return 'SQUARE';
    case AppEmbedData_ImageStyles_AspectRatio.RECTANGLE:
      return 'RECTANGLE';
    default:
      return 'UNKNOWN';
  }
}

export function appEmbedData_ImageStyles_ResizingFromJSON(
  object: any
): AppEmbedData_ImageStyles_Resizing {
  switch (object) {
    case 0:
    case 'FILL':
      return AppEmbedData_ImageStyles_Resizing.FILL;
    case 1:
    case 'FIT':
      return AppEmbedData_ImageStyles_Resizing.FIT;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AppEmbedData_ImageStyles_Resizing.UNRECOGNIZED;
  }
}

export function appEmbedData_ImageStyles_ResizingToJSON(
  object: AppEmbedData_ImageStyles_Resizing
): string {
  switch (object) {
    case AppEmbedData_ImageStyles_Resizing.FILL:
      return 'FILL';
    case AppEmbedData_ImageStyles_Resizing.FIT:
      return 'FIT';
    default:
      return 'UNKNOWN';
  }
}

export interface AppEmbedData_RibbonStyles {
  /** Text to display on the ribbon. */
  ribbonText?: string;
  /** Ribbon background color as a hexadecimal value. */
  backgroundColor?: string;
  /** Ribbon text color as a hexadecimal value. */
  textColor?: string;
  /** Ribbon border color as a hexadecimal value. */
  borderColor?: string;
  /** Ribbon border width in pixels. */
  borderWidth?: number;
  /** Ribbon border radius in pixels. */
  borderRadius?: number;
  /** Placement of the ribbon. Defaults to `IMAGE`. */
  ribbonPlacement: AppEmbedData_RibbonStyles_Placement;
}

export function appEmbedData_RibbonStyles_PlacementFromJSON(
  object: any
): AppEmbedData_RibbonStyles_Placement {
  switch (object) {
    case 0:
    case 'IMAGE':
      return AppEmbedData_RibbonStyles_Placement.IMAGE;
    case 1:
    case 'PRODUCT_INFO':
      return AppEmbedData_RibbonStyles_Placement.PRODUCT_INFO;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AppEmbedData_RibbonStyles_Placement.UNRECOGNIZED;
  }
}

export function appEmbedData_RibbonStyles_PlacementToJSON(
  object: AppEmbedData_RibbonStyles_Placement
): string {
  switch (object) {
    case AppEmbedData_RibbonStyles_Placement.IMAGE:
      return 'IMAGE';
    case AppEmbedData_RibbonStyles_Placement.PRODUCT_INFO:
      return 'PRODUCT_INFO';
    default:
      return 'UNKNOWN';
  }
}

export interface AppEmbedData_CardStyles {
  /** Card background color as a hexadecimal value. */
  backgroundColor?: string;
  /** Card border color as a hexadecimal value. */
  borderColor?: string;
  /** Card border width in pixels. */
  borderWidth?: number;
  /** Card border radius in pixels. */
  borderRadius?: number;
  /** Card type. Defaults to `CONTAINED`. */
  type: AppEmbedData_CardStyles_Type;
  /** Content alignment. Defaults to `START`. */
  alignment: AppEmbedData_CardStyles_Alignment;
  /** Layout for title and price. Defaults to `STACKED`. */
  titlePriceLayout: AppEmbedData_CardStyles_Layout;
  /** Title text color as a hexadecimal value. */
  titleColor?: string;
  /** Text color as a hexadecimal value. */
  textColor?: string;
}

export function appEmbedData_CardStyles_TypeFromJSON(object: any): AppEmbedData_CardStyles_Type {
  switch (object) {
    case 0:
    case 'CONTAINED':
      return AppEmbedData_CardStyles_Type.CONTAINED;
    case 1:
    case 'FRAMELESS':
      return AppEmbedData_CardStyles_Type.FRAMELESS;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AppEmbedData_CardStyles_Type.UNRECOGNIZED;
  }
}

export function appEmbedData_CardStyles_TypeToJSON(object: AppEmbedData_CardStyles_Type): string {
  switch (object) {
    case AppEmbedData_CardStyles_Type.CONTAINED:
      return 'CONTAINED';
    case AppEmbedData_CardStyles_Type.FRAMELESS:
      return 'FRAMELESS';
    default:
      return 'UNKNOWN';
  }
}

export function appEmbedData_CardStyles_AlignmentFromJSON(
  object: any
): AppEmbedData_CardStyles_Alignment {
  switch (object) {
    case 0:
    case 'START':
      return AppEmbedData_CardStyles_Alignment.START;
    case 1:
    case 'CENTER':
      return AppEmbedData_CardStyles_Alignment.CENTER;
    case 2:
    case 'END':
      return AppEmbedData_CardStyles_Alignment.END;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AppEmbedData_CardStyles_Alignment.UNRECOGNIZED;
  }
}

export function appEmbedData_CardStyles_AlignmentToJSON(
  object: AppEmbedData_CardStyles_Alignment
): string {
  switch (object) {
    case AppEmbedData_CardStyles_Alignment.START:
      return 'START';
    case AppEmbedData_CardStyles_Alignment.CENTER:
      return 'CENTER';
    case AppEmbedData_CardStyles_Alignment.END:
      return 'END';
    default:
      return 'UNKNOWN';
  }
}

export function appEmbedData_CardStyles_LayoutFromJSON(
  object: any
): AppEmbedData_CardStyles_Layout {
  switch (object) {
    case 0:
    case 'STACKED':
      return AppEmbedData_CardStyles_Layout.STACKED;
    case 1:
    case 'SIDE_BY_SIDE':
      return AppEmbedData_CardStyles_Layout.SIDE_BY_SIDE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AppEmbedData_CardStyles_Layout.UNRECOGNIZED;
  }
}

export function appEmbedData_CardStyles_LayoutToJSON(
  object: AppEmbedData_CardStyles_Layout
): string {
  switch (object) {
    case AppEmbedData_CardStyles_Layout.STACKED:
      return 'STACKED';
    case AppEmbedData_CardStyles_Layout.SIDE_BY_SIDE:
      return 'SIDE_BY_SIDE';
    default:
      return 'UNKNOWN';
  }
}

export interface AppEmbedData_BookingData {
  /** Booking duration in minutes. */
  durations?: string;
}

export interface AppEmbedData_EventData {
  /** Event schedule. */
  scheduling?: string;
  /** Event location. */
  location?: string;
}

export interface AppEmbedData_PricingData {
  /** Minimum numeric price value as string (e.g., "10.99"). */
  valueFrom?: string;
  /** Maximum numeric price value as string (e.g., "19.99"). */
  valueTo?: string;
  /** Numeric price value as string after discount application (e.g., "15.99"). */
  discountedValue?: string;
  /** Currency of the value in ISO 4217 format (e.g., "USD", "EUR"). */
  currency?: string;
  /** Pricing plan ID. */
  pricingPlanId?: string;
}

const baseAppEmbedData: object = { type: AppEmbedData_AppType.PRODUCT };

export const AppEmbedData = {
  fromJSON(object: any): AppEmbedData {
    const message = { ...baseAppEmbedData } as AppEmbedData;
    message.type =
      object.type !== undefined && object.type !== null
        ? appEmbedData_AppTypeFromJSON(object.type)
        : AppEmbedData_AppType.PRODUCT;
    message.itemId =
      object.itemId !== undefined && object.itemId !== null ? String(object.itemId) : undefined;
    message.name =
      object.name !== undefined && object.name !== null ? String(object.name) : undefined;
    message.imageSrc =
      object.imageSrc !== undefined && object.imageSrc !== null
        ? String(object.imageSrc)
        : undefined;
    message.url = object.url !== undefined && object.url !== null ? String(object.url) : undefined;
    message.image =
      object.image !== undefined && object.image !== null
        ? Media.fromJSON(object.image)
        : undefined;
    message.bookingData =
      object.bookingData !== undefined && object.bookingData !== null
        ? AppEmbedData_BookingData.fromJSON(object.bookingData)
        : undefined;
    message.eventData =
      object.eventData !== undefined && object.eventData !== null
        ? AppEmbedData_EventData.fromJSON(object.eventData)
        : undefined;
    message.hideImage =
      object.hideImage !== undefined && object.hideImage !== null
        ? Boolean(object.hideImage)
        : undefined;
    message.hideTitle =
      object.hideTitle !== undefined && object.hideTitle !== null
        ? Boolean(object.hideTitle)
        : undefined;
    message.hidePrice =
      object.hidePrice !== undefined && object.hidePrice !== null
        ? Boolean(object.hidePrice)
        : undefined;
    message.hideDescription =
      object.hideDescription !== undefined && object.hideDescription !== null
        ? Boolean(object.hideDescription)
        : undefined;
    message.hideDateTime =
      object.hideDateTime !== undefined && object.hideDateTime !== null
        ? Boolean(object.hideDateTime)
        : undefined;
    message.hideLocation =
      object.hideLocation !== undefined && object.hideLocation !== null
        ? Boolean(object.hideLocation)
        : undefined;
    message.hideDuration =
      object.hideDuration !== undefined && object.hideDuration !== null
        ? Boolean(object.hideDuration)
        : undefined;
    message.hideButton =
      object.hideButton !== undefined && object.hideButton !== null
        ? Boolean(object.hideButton)
        : undefined;
    message.hideRibbon =
      object.hideRibbon !== undefined && object.hideRibbon !== null
        ? Boolean(object.hideRibbon)
        : undefined;
    message.buttonStyles =
      object.buttonStyles !== undefined && object.buttonStyles !== null
        ? AppEmbedData_ButtonStyles.fromJSON(object.buttonStyles)
        : undefined;
    message.imageStyles =
      object.imageStyles !== undefined && object.imageStyles !== null
        ? AppEmbedData_ImageStyles.fromJSON(object.imageStyles)
        : undefined;
    message.ribbonStyles =
      object.ribbonStyles !== undefined && object.ribbonStyles !== null
        ? AppEmbedData_RibbonStyles.fromJSON(object.ribbonStyles)
        : undefined;
    message.cardStyles =
      object.cardStyles !== undefined && object.cardStyles !== null
        ? AppEmbedData_CardStyles.fromJSON(object.cardStyles)
        : undefined;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.pricingData =
      object.pricingData !== undefined && object.pricingData !== null
        ? AppEmbedData_PricingData.fromJSON(object.pricingData)
        : undefined;
    return message;
  },

  toJSON(message: AppEmbedData): unknown {
    const obj: any = {};
    message.type !== undefined && (obj.type = appEmbedData_AppTypeToJSON(message.type));
    message.itemId !== undefined && (obj.itemId = message.itemId);
    message.name !== undefined && (obj.name = message.name);
    message.imageSrc !== undefined && (obj.imageSrc = message.imageSrc);
    message.url !== undefined && (obj.url = message.url);
    message.image !== undefined &&
      (obj.image = message.image ? Media.toJSON(message.image) : undefined);
    message.bookingData !== undefined &&
      (obj.bookingData = message.bookingData
        ? AppEmbedData_BookingData.toJSON(message.bookingData)
        : undefined);
    message.eventData !== undefined &&
      (obj.eventData = message.eventData
        ? AppEmbedData_EventData.toJSON(message.eventData)
        : undefined);
    message.hideImage !== undefined && (obj.hideImage = message.hideImage);
    message.hideTitle !== undefined && (obj.hideTitle = message.hideTitle);
    message.hidePrice !== undefined && (obj.hidePrice = message.hidePrice);
    message.hideDescription !== undefined && (obj.hideDescription = message.hideDescription);
    message.hideDateTime !== undefined && (obj.hideDateTime = message.hideDateTime);
    message.hideLocation !== undefined && (obj.hideLocation = message.hideLocation);
    message.hideDuration !== undefined && (obj.hideDuration = message.hideDuration);
    message.hideButton !== undefined && (obj.hideButton = message.hideButton);
    message.hideRibbon !== undefined && (obj.hideRibbon = message.hideRibbon);
    message.buttonStyles !== undefined &&
      (obj.buttonStyles = message.buttonStyles
        ? AppEmbedData_ButtonStyles.toJSON(message.buttonStyles)
        : undefined);
    message.imageStyles !== undefined &&
      (obj.imageStyles = message.imageStyles
        ? AppEmbedData_ImageStyles.toJSON(message.imageStyles)
        : undefined);
    message.ribbonStyles !== undefined &&
      (obj.ribbonStyles = message.ribbonStyles
        ? AppEmbedData_RibbonStyles.toJSON(message.ribbonStyles)
        : undefined);
    message.cardStyles !== undefined &&
      (obj.cardStyles = message.cardStyles
        ? AppEmbedData_CardStyles.toJSON(message.cardStyles)
        : undefined);
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.pricingData !== undefined &&
      (obj.pricingData = message.pricingData
        ? AppEmbedData_PricingData.toJSON(message.pricingData)
        : undefined);
    return obj;
  },
};

const baseAppEmbedData_ButtonStyles: object = {};

export const AppEmbedData_ButtonStyles = {
  fromJSON(object: any): AppEmbedData_ButtonStyles {
    const message = { ...baseAppEmbedData_ButtonStyles } as AppEmbedData_ButtonStyles;
    message.buttonText =
      object.buttonText !== undefined && object.buttonText !== null
        ? String(object.buttonText)
        : undefined;
    message.borderWidth =
      object.borderWidth !== undefined && object.borderWidth !== null
        ? Number(object.borderWidth)
        : undefined;
    message.borderRadius =
      object.borderRadius !== undefined && object.borderRadius !== null
        ? Number(object.borderRadius)
        : undefined;
    message.borderColor =
      object.borderColor !== undefined && object.borderColor !== null
        ? String(object.borderColor)
        : undefined;
    message.textColor =
      object.textColor !== undefined && object.textColor !== null
        ? String(object.textColor)
        : undefined;
    message.backgroundColor =
      object.backgroundColor !== undefined && object.backgroundColor !== null
        ? String(object.backgroundColor)
        : undefined;
    message.borderColorHover =
      object.borderColorHover !== undefined && object.borderColorHover !== null
        ? String(object.borderColorHover)
        : undefined;
    message.textColorHover =
      object.textColorHover !== undefined && object.textColorHover !== null
        ? String(object.textColorHover)
        : undefined;
    message.backgroundColorHover =
      object.backgroundColorHover !== undefined && object.backgroundColorHover !== null
        ? String(object.backgroundColorHover)
        : undefined;
    message.buttonSize =
      object.buttonSize !== undefined && object.buttonSize !== null
        ? String(object.buttonSize)
        : undefined;
    return message;
  },

  toJSON(message: AppEmbedData_ButtonStyles): unknown {
    const obj: any = {};
    message.buttonText !== undefined && (obj.buttonText = message.buttonText);
    message.borderWidth !== undefined && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== undefined && (obj.borderRadius = message.borderRadius);
    message.borderColor !== undefined && (obj.borderColor = message.borderColor);
    message.textColor !== undefined && (obj.textColor = message.textColor);
    message.backgroundColor !== undefined && (obj.backgroundColor = message.backgroundColor);
    message.borderColorHover !== undefined && (obj.borderColorHover = message.borderColorHover);
    message.textColorHover !== undefined && (obj.textColorHover = message.textColorHover);
    message.backgroundColorHover !== undefined &&
      (obj.backgroundColorHover = message.backgroundColorHover);
    message.buttonSize !== undefined && (obj.buttonSize = message.buttonSize);
    return obj;
  },
};

const baseAppEmbedData_ImageStyles: object = {
  imagePosition: AppEmbedData_ImageStyles_Position.START,
  aspectRatio: AppEmbedData_ImageStyles_AspectRatio.SQUARE,
  resizing: AppEmbedData_ImageStyles_Resizing.FILL,
};

export const AppEmbedData_ImageStyles = {
  fromJSON(object: any): AppEmbedData_ImageStyles {
    const message = { ...baseAppEmbedData_ImageStyles } as AppEmbedData_ImageStyles;
    message.hideImage =
      object.hideImage !== undefined && object.hideImage !== null
        ? Boolean(object.hideImage)
        : undefined;
    message.imagePosition =
      object.imagePosition !== undefined && object.imagePosition !== null
        ? appEmbedData_ImageStyles_PositionFromJSON(object.imagePosition)
        : AppEmbedData_ImageStyles_Position.START;
    message.aspectRatio =
      object.aspectRatio !== undefined && object.aspectRatio !== null
        ? appEmbedData_ImageStyles_AspectRatioFromJSON(object.aspectRatio)
        : AppEmbedData_ImageStyles_AspectRatio.SQUARE;
    message.resizing =
      object.resizing !== undefined && object.resizing !== null
        ? appEmbedData_ImageStyles_ResizingFromJSON(object.resizing)
        : AppEmbedData_ImageStyles_Resizing.FILL;
    message.borderColor =
      object.borderColor !== undefined && object.borderColor !== null
        ? String(object.borderColor)
        : undefined;
    message.borderWidth =
      object.borderWidth !== undefined && object.borderWidth !== null
        ? Number(object.borderWidth)
        : undefined;
    message.borderRadius =
      object.borderRadius !== undefined && object.borderRadius !== null
        ? Number(object.borderRadius)
        : undefined;
    return message;
  },

  toJSON(message: AppEmbedData_ImageStyles): unknown {
    const obj: any = {};
    message.hideImage !== undefined && (obj.hideImage = message.hideImage);
    message.imagePosition !== undefined &&
      (obj.imagePosition = appEmbedData_ImageStyles_PositionToJSON(message.imagePosition));
    message.aspectRatio !== undefined &&
      (obj.aspectRatio = appEmbedData_ImageStyles_AspectRatioToJSON(message.aspectRatio));
    message.resizing !== undefined &&
      (obj.resizing = appEmbedData_ImageStyles_ResizingToJSON(message.resizing));
    message.borderColor !== undefined && (obj.borderColor = message.borderColor);
    message.borderWidth !== undefined && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== undefined && (obj.borderRadius = message.borderRadius);
    return obj;
  },
};

const baseAppEmbedData_RibbonStyles: object = {
  ribbonPlacement: AppEmbedData_RibbonStyles_Placement.IMAGE,
};

export const AppEmbedData_RibbonStyles = {
  fromJSON(object: any): AppEmbedData_RibbonStyles {
    const message = { ...baseAppEmbedData_RibbonStyles } as AppEmbedData_RibbonStyles;
    message.ribbonText =
      object.ribbonText !== undefined && object.ribbonText !== null
        ? String(object.ribbonText)
        : undefined;
    message.backgroundColor =
      object.backgroundColor !== undefined && object.backgroundColor !== null
        ? String(object.backgroundColor)
        : undefined;
    message.textColor =
      object.textColor !== undefined && object.textColor !== null
        ? String(object.textColor)
        : undefined;
    message.borderColor =
      object.borderColor !== undefined && object.borderColor !== null
        ? String(object.borderColor)
        : undefined;
    message.borderWidth =
      object.borderWidth !== undefined && object.borderWidth !== null
        ? Number(object.borderWidth)
        : undefined;
    message.borderRadius =
      object.borderRadius !== undefined && object.borderRadius !== null
        ? Number(object.borderRadius)
        : undefined;
    message.ribbonPlacement =
      object.ribbonPlacement !== undefined && object.ribbonPlacement !== null
        ? appEmbedData_RibbonStyles_PlacementFromJSON(object.ribbonPlacement)
        : AppEmbedData_RibbonStyles_Placement.IMAGE;
    return message;
  },

  toJSON(message: AppEmbedData_RibbonStyles): unknown {
    const obj: any = {};
    message.ribbonText !== undefined && (obj.ribbonText = message.ribbonText);
    message.backgroundColor !== undefined && (obj.backgroundColor = message.backgroundColor);
    message.textColor !== undefined && (obj.textColor = message.textColor);
    message.borderColor !== undefined && (obj.borderColor = message.borderColor);
    message.borderWidth !== undefined && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== undefined && (obj.borderRadius = message.borderRadius);
    message.ribbonPlacement !== undefined &&
      (obj.ribbonPlacement = appEmbedData_RibbonStyles_PlacementToJSON(message.ribbonPlacement));
    return obj;
  },
};

const baseAppEmbedData_CardStyles: object = {
  type: AppEmbedData_CardStyles_Type.CONTAINED,
  alignment: AppEmbedData_CardStyles_Alignment.START,
  titlePriceLayout: AppEmbedData_CardStyles_Layout.STACKED,
};

export const AppEmbedData_CardStyles = {
  fromJSON(object: any): AppEmbedData_CardStyles {
    const message = { ...baseAppEmbedData_CardStyles } as AppEmbedData_CardStyles;
    message.backgroundColor =
      object.backgroundColor !== undefined && object.backgroundColor !== null
        ? String(object.backgroundColor)
        : undefined;
    message.borderColor =
      object.borderColor !== undefined && object.borderColor !== null
        ? String(object.borderColor)
        : undefined;
    message.borderWidth =
      object.borderWidth !== undefined && object.borderWidth !== null
        ? Number(object.borderWidth)
        : undefined;
    message.borderRadius =
      object.borderRadius !== undefined && object.borderRadius !== null
        ? Number(object.borderRadius)
        : undefined;
    message.type =
      object.type !== undefined && object.type !== null
        ? appEmbedData_CardStyles_TypeFromJSON(object.type)
        : AppEmbedData_CardStyles_Type.CONTAINED;
    message.alignment =
      object.alignment !== undefined && object.alignment !== null
        ? appEmbedData_CardStyles_AlignmentFromJSON(object.alignment)
        : AppEmbedData_CardStyles_Alignment.START;
    message.titlePriceLayout =
      object.titlePriceLayout !== undefined && object.titlePriceLayout !== null
        ? appEmbedData_CardStyles_LayoutFromJSON(object.titlePriceLayout)
        : AppEmbedData_CardStyles_Layout.STACKED;
    message.titleColor =
      object.titleColor !== undefined && object.titleColor !== null
        ? String(object.titleColor)
        : undefined;
    message.textColor =
      object.textColor !== undefined && object.textColor !== null
        ? String(object.textColor)
        : undefined;
    return message;
  },

  toJSON(message: AppEmbedData_CardStyles): unknown {
    const obj: any = {};
    message.backgroundColor !== undefined && (obj.backgroundColor = message.backgroundColor);
    message.borderColor !== undefined && (obj.borderColor = message.borderColor);
    message.borderWidth !== undefined && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== undefined && (obj.borderRadius = message.borderRadius);
    message.type !== undefined && (obj.type = appEmbedData_CardStyles_TypeToJSON(message.type));
    message.alignment !== undefined &&
      (obj.alignment = appEmbedData_CardStyles_AlignmentToJSON(message.alignment));
    message.titlePriceLayout !== undefined &&
      (obj.titlePriceLayout = appEmbedData_CardStyles_LayoutToJSON(message.titlePriceLayout));
    message.titleColor !== undefined && (obj.titleColor = message.titleColor);
    message.textColor !== undefined && (obj.textColor = message.textColor);
    return obj;
  },
};

const baseAppEmbedData_BookingData: object = {};

export const AppEmbedData_BookingData = {
  fromJSON(object: any): AppEmbedData_BookingData {
    const message = { ...baseAppEmbedData_BookingData } as AppEmbedData_BookingData;
    message.durations =
      object.durations !== undefined && object.durations !== null
        ? String(object.durations)
        : undefined;
    return message;
  },

  toJSON(message: AppEmbedData_BookingData): unknown {
    const obj: any = {};
    message.durations !== undefined && (obj.durations = message.durations);
    return obj;
  },
};

const baseAppEmbedData_EventData: object = {};

export const AppEmbedData_EventData = {
  fromJSON(object: any): AppEmbedData_EventData {
    const message = { ...baseAppEmbedData_EventData } as AppEmbedData_EventData;
    message.scheduling =
      object.scheduling !== undefined && object.scheduling !== null
        ? String(object.scheduling)
        : undefined;
    message.location =
      object.location !== undefined && object.location !== null
        ? String(object.location)
        : undefined;
    return message;
  },

  toJSON(message: AppEmbedData_EventData): unknown {
    const obj: any = {};
    message.scheduling !== undefined && (obj.scheduling = message.scheduling);
    message.location !== undefined && (obj.location = message.location);
    return obj;
  },
};

const baseAppEmbedData_PricingData: object = {};

export const AppEmbedData_PricingData = {
  fromJSON(object: any): AppEmbedData_PricingData {
    const message = { ...baseAppEmbedData_PricingData } as AppEmbedData_PricingData;
    message.valueFrom =
      object.valueFrom !== undefined && object.valueFrom !== null
        ? String(object.valueFrom)
        : undefined;
    message.valueTo =
      object.valueTo !== undefined && object.valueTo !== null ? String(object.valueTo) : undefined;
    message.discountedValue =
      object.discountedValue !== undefined && object.discountedValue !== null
        ? String(object.discountedValue)
        : undefined;
    message.currency =
      object.currency !== undefined && object.currency !== null
        ? String(object.currency)
        : undefined;
    message.pricingPlanId =
      object.pricingPlanId !== undefined && object.pricingPlanId !== null
        ? String(object.pricingPlanId)
        : undefined;
    return message;
  },

  toJSON(message: AppEmbedData_PricingData): unknown {
    const obj: any = {};
    message.valueFrom !== undefined && (obj.valueFrom = message.valueFrom);
    message.valueTo !== undefined && (obj.valueTo = message.valueTo);
    message.discountedValue !== undefined && (obj.discountedValue = message.discountedValue);
    message.currency !== undefined && (obj.currency = message.currency);
    message.pricingPlanId !== undefined && (obj.pricingPlanId = message.pricingPlanId);
    return obj;
  },
};
